import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IThirdPartyLineOfBusiness } from '@ruby/modules/third-party/models/third-party.interface';
import { selectThirdPartyContractState } from '@ruby/modules/third-party/store';
import * as fromThirdPartyCore from '@ruby/modules/third-party/store/reducers/third-party-core.reducer';
import { fromThirdPartyAuthorization } from '@ruby/modules/third-party/store/third-party-authorization.index';
import { fromThirdPartyCompanies } from '@ruby/modules/third-party/store/third-party-companies.index';
import { ThirdPartyCoreActions } from '@ruby/modules/third-party/store/third-party-core.index';
import { fromThirdPartyStepper, ThirdPartyStepperActions } from '@ruby/modules/third-party/store/third-party-stepper.index';

@Component({
  selector: 'ng-third-party-contract-container',
  templateUrl: './third-contract.container.html',
  styleUrls: ['./third-contract.container.scss']
})
export class ThirdPartyContractContainerComponent implements OnDestroy {
  store$: Observable<{
    core: fromThirdPartyCore.State;
    authorizations: fromThirdPartyAuthorization.State;
    companies: fromThirdPartyCompanies.State;
    stepper: fromThirdPartyStepper.State;
    contractId?: string;
  }>;
  contractId?: string;
  lineOfBusiness!: Array<IThirdPartyLineOfBusiness>;
  index!: number;
  isEdit!: boolean;
  isDoneEnabled!: boolean;
  private subscription!: Subscription;

  constructor(private store: Store<fromThirdPartyCore.State>, private router: Router) {
    this.subscription = fromEvent(window, 'popstate').subscribe((event: Event) => this.cancel());
    this.store$ = this.store.select(selectThirdPartyContractState).pipe(
      tap((st: {
        core: fromThirdPartyCore.State;
        authorizations: fromThirdPartyAuthorization.State;
        companies: fromThirdPartyCompanies.State;
        stepper: fromThirdPartyStepper.State;
        contractId?: string;
      }) => {
        this.lineOfBusiness = st.authorizations.lob;
        this.index = st.stepper.stepIndex;
        this.isDoneEnabled = st.stepper.isDoneEnabled;
        this.isEdit = st.stepper.isEdit;

        if (st.contractId && st.contractId !== this.contractId) {
          this.contractId = st.contractId;
          this.loadContract();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Load Contract
   *
   * @summary This function loads a contract if the contractId is provided in the url
   * @returns void
   */
  loadContract(): void {
    this.store.dispatch(ThirdPartyStepperActions.setEditMode({ data: true }));
    this.store.dispatch(ThirdPartyStepperActions.setStepIndex({ data: 2 }));
    this.store.dispatch(ThirdPartyCoreActions.loadContract({ data: this.contractId! }));
  }

  /**
   * Cancel
   *
   * @summary This function navigates to the 3PL grid and clean the stepper store
   * @returns void
   */
  cancel(): void {
    this.store.dispatch(ThirdPartyCoreActions.hardReset({ data: true }));
    this.router.navigate(['home/third-party-providers']);
  }
}
